var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUnlinkIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    stroke: "#D74142",
    fill: "none",
    strokeWidth: 2,
    viewBox: "0 0 24 24",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    height: 24,
    width: 24,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 15l3 -3m2 -2l1 -1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11 6l.463 -.536a5 5 0 0 1 7.071 7.072l-.534 .464"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3 3l18 18"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13 18l-.397 .534a5.068 5.068 0 0 1 -7.127 0a4.972 4.972 0 0 1 0 -7.071l.524 -.463"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnlinkIcon);
export default __webpack_public_path__ + "static/media/unlink-icon.6e770936ffad1ff3b78bd10dc8818446.svg";
export { ForwardRef as ReactComponent };